import { cx } from "@unizpay/ui";

/** The first letter of a profile's name in a rounded square, like a workspace icon. */
export function ProfileAvatar({ name, className }: { name: string; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cx(
        "flex size-6 shrink-0 items-center justify-center rounded-md bg-accent text-xs font-semibold text-accent-fg",
        className,
      )}
    >
      {(name.trim().charAt(0) || "?").toUpperCase()}
    </span>
  );
}
